import { render, staticRenderFns } from "./ai-diagnosis.vue?vue&type=template&id=5e840a32&scoped=true"
import script from "./ai-diagnosis.vue?vue&type=script&lang=js"
export * from "./ai-diagnosis.vue?vue&type=script&lang=js"
import style0 from "./ai-diagnosis.vue?vue&type=style&index=0&id=5e840a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e840a32",
  null
  
)

export default component.exports